'use client';

import { Typography, useMediaQuery } from '@prenuvo/halo-web';

import { DesktopStepsSvg, MobileStepsSvg } from './StepsSVG';

export const NextSteps = () => {
  const isMobile = useMediaQuery('(max-width: 800px)');

  return (
    <div className="flex flex-col justify-center border-t border-neutral-100 py-6">
      <Typography variant="h4" as="h4">
        What are the next steps?
      </Typography>
      <div className="my-4">{isMobile ? <MobileStepsSvg /> : <DesktopStepsSvg />}</div>
    </div>
  );
};
